const Pusher = require("pusher-js");
// import {
//     useStore
// } from 'vuex'
import store from "@/store/store.js";
// import router from '@/router/router'
// const store = useStore()
// const token = store.getters.GET_TOKEN;
// const userId = store.getters.GET_USER_DATA.id;

const PUSHER_ID = process.env.VUE_APP_PUSHER_ID;
const PUSHER_KEY = process.env.VUE_APP_PUSHER_KEY;
const PUSHER_SECRET = process.env.VUE_APP_PUSHER_SECRET;
const PUSHER_CLUSTER = process.env.VUE_APP_PUSHER_CLUSTER;

const PUSHER_CHAT_ENDPOINT =
  process.env.VUE_APP_BASEURL + process.env.VUE_APP_PUSHER_CHAT_ENDPOINT;
const PUSHER_CHAT_PREFIX = process.env.VUE_APP_PUSHER_PRIVATE_CHAT_PREFIX;
const PUSHER_CHAT_EVENT = process.env.VUE_APP_PUSHER_CHAT_EVENT;

const PUSHER_NOTIFICATIONS_ENDPOINT =
  process.env.VUE_APP_BASEURL +
  process.env.VUE_APP_PUSHER_NOTIFICATIONS_ENDPOINT;
const PUSHER_NOTIFICATIONS_PREFIX =
  process.env.VUE_APP_PUSHER_PRIVATE_NOTIFICATIONS_PREFIX;
const PUSHER_NOTIFICATIONS_EVENT =
  process.env.VUE_APP_PUSHER_NOTIFICATIONS_EVENT;


class PusherHooks {
  constructor(mitt) {
    this.mitt = mitt;

    this.pusher = {};
    const pusherSettings = {
      appId: PUSHER_ID,
      secret: PUSHER_SECRET,
      cluster: PUSHER_CLUSTER,
      auth: {
        headers: {
          Authorization: null,
        },
      },
    };
    let pusherChatSettings = pusherSettings;
    pusherChatSettings.authEndpoint = PUSHER_CHAT_ENDPOINT;
    this.pusher.chat = new Pusher(PUSHER_KEY, pusherChatSettings);
    this.socketId = null;

    let pusherNotificationsSettings = pusherSettings;
    pusherChatSettings.authEndpoint = PUSHER_NOTIFICATIONS_ENDPOINT;
    this.pusher.notifications = new Pusher(
      PUSHER_KEY,
      pusherNotificationsSettings
    );
  }
  get instance() {
    return this.pusher;
  }

  setToken(token) {
    this.pusher.chat.config.auth.headers.Authorization = `Bearer ${token}`;
    this.pusher.notifications.config.auth.headers.Authorization = `Bearer ${token}`;
  }
  pusherChatSubscribe(chatId) {

    if (chatId) {
      this.pusher.chat.subscribe(PUSHER_CHAT_PREFIX + chatId);
    } else {
      console.log("No chat ID");
    }
  }
  pusherNotificationsSubscribe(userId) {

    this.pusher.notifications.subscribe(PUSHER_NOTIFICATIONS_PREFIX + userId);
  }
  pusherBind() {
    this.pusher.chat.bind(PUSHER_CHAT_EVENT, (data) => {

      // this.mitt.emit('chatEvent', data);

      if (data.data.type == "chats_data") {
        store.commit("SET_CHAT_LAST_MESSAGE", data);
      }
      store.dispatch("CHECK_CHAT_UNREAD_MESSAGES");
    });
    this.pusher.notifications.bind(PUSHER_NOTIFICATIONS_EVENT, (data) => {
      const user = store.getters.GET_USER_DATA;
      const userId = user.id;

      // data.data.data.link = this.generateNotificationLink(data.data.data);

      if (data.data.data.type == 0) {
        this.mitt.emit("chatEvent", data);
      }

      if (data.data.data.show && data.data.data.from != userId) {
        store.commit("ADD_NOTIFICATIONS_MESSAGE", data.data.data);
        store.commit("SET_NOTIFICATIONS_UNREAD_MESSAGES", data.data.unread);
      }
    });
  }

  // generateNotificationLink(data) {
  //   let link = null;
  //
  //   switch (data.type) {
  //     case 0:
  //       link = {
  //         name: "chat_message",
  //         params: {
  //           chatId: data.params.id,
  //           // opponentId: user.value.id
  //         },
  //       };
  //
  //       break;
  //
  //     case 13:
  //     case 14:
  //       link = {
  //         name: "shift_confirm",
  //         params: {
  //           shiftId: data.params.id,
  //         },
  //       };
  //
  //       break;
  //
  //     case 7:
  //     case 11:
  //     case 15:
  //     case 17:
  //     case 18:
  //     case 20:
  //     case 21:
  //     case 16:
  //     case 12:
  //       link = {
  //         name: "job",
  //         params: {
  //           jobId: data.params.id,
  //         },
  //       };
  //
  //       break;
  //
  //   }
  //   return link;
  // }

}

export default {
  install(app, mitt) {
    app.config.globalProperties.pusher = new PusherHooks(mitt);
    app.provide("pusher", app.config.globalProperties.pusher);
  },
};

// export default pusher

// export {
//     pusherHooks
// }
